import AccessibilityHandler from './accessibility-handler';

export default new AccessibilityHandler(document);
